import React from 'react';
import './Methodology.scss';
import { safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

const Methodology = ({strapiData}) => {
    return (
        <section className="methodology">
            <div className="methodology__part">
                <div className="methodology__content">
                    <h2>{strapiData.Titre}</h2>
                    <div className="introduction__text-block" dangerouslySetInnerHTML={safeHtml(strapiData.Texte)} />
                </div>
                <div className="methodology__image-container">
                    <div className="methodology__image-wrapper">
                        <StrapiImageWithSkeleton
                            picture={strapiData.Photo}
                            loading="lazy"
                            size='small'
                        />
                    </div>
                    <div className="methodology__image-shadow"></div>
                </div>
            </div>
        </section>
    );
};

export default Methodology;